import { render, staticRenderFns } from "./huaxing.vue?vue&type=template&id=bd2394b8&scoped=true&"
import script from "./huaxing.vue?vue&type=script&lang=js&"
export * from "./huaxing.vue?vue&type=script&lang=js&"
import style0 from "./huaxing.vue?vue&type=style&index=0&id=bd2394b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2394b8",
  null
  
)

export default component.exports